export default __webpack_public_path__ + "static/how-to-discover-your-perfect-winter-wonderland-vienna-70f477dabc0864fd2dcac6329b389a61.jpg";